import { render, staticRenderFns } from "./TableVolunteeringOpportunities.vue?vue&type=template&id=93f22c12"
import script from "./TableVolunteeringOpportunities.vue?vue&type=script&lang=js"
export * from "./TableVolunteeringOpportunities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports